module.exports = __webpack_public_path__ + "img/withdraw.2e2114b7.svg";